import React from "react";
import {Switch, Route} from 'react-router-dom';
import Calculator from "./features/calculator/Calculator";

function App() {

  return (

    <Switch>
      <Route path="/">
        <Calculator />
      </Route>
    </Switch>
  );
}

export default App;

